var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { IConfigurationRepositoryType, Observable, inject, injectable } from '@serviceos-rn/core';
import { ITipRepositoryType } from '../ITipRepository';
import { ITipPayloadRepositoryType } from '../ITipPayloadRepository';
import { ITipConfigurationRepositoryType } from '../ITipConfigurationRepository';
let GetTipStateUseCase = class GetTipStateUseCase {
    constructor(repository, tipConfigurationRepository, payloadRepository, configurationRepository) {
        this.repository = repository;
        this.tipConfigurationRepository = tipConfigurationRepository;
        this.payloadRepository = payloadRepository;
        this.configurationRepository = configurationRepository;
        this.tipState = new Observable();
    }
    getTipState(tip) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
        const update = {
            tip: Object.assign({}, tip),
            interactions: []
        };
        const texts = this.tipConfigurationRepository.getTipScreenText();
        if (((_a = update.tip.customize) === null || _a === void 0 ? void 0 : _a.status) === 'error') {
            update.interactions.push({
                type: 'primary',
                action: 'tryAgain',
                text: texts.value.try_again_button_title || ((_d = (_c = (_b = this.configurationRepository.configuration.value.tip) === null || _b === void 0 ? void 0 : _b.components) === null || _c === void 0 ? void 0 : _c.tip_screen) === null || _d === void 0 ? void 0 : _d.try_again_button_title) || 'TRY AGAIN'
            });
        }
        if (!((_e = update.tip.customize) === null || _e === void 0 ? void 0 : _e.tipped)) {
            if (this.payloadRepository.getMode().value === 'compact') {
                return update;
            }
            const selectedChoiceItem = (_f = tip.choice_items) === null || _f === void 0 ? void 0 : _f.find(item => item.value === 1);
            update.interactions.push({
                type: 'primary',
                action: 'send',
                disabled: !selectedChoiceItem,
                text: this.payloadRepository.getTip().value
                    ? texts.value.add_tip_button_title || ((_j = (_h = (_g = this.configurationRepository.configuration.value.tip) === null || _g === void 0 ? void 0 : _g.components) === null || _h === void 0 ? void 0 : _h.tip_screen) === null || _j === void 0 ? void 0 : _j.add_tip_button_title) || 'ADD TIP'
                    : texts.value.send_tip_button_title || ((_m = (_l = (_k = this.configurationRepository.configuration.value.tip) === null || _k === void 0 ? void 0 : _k.components) === null || _l === void 0 ? void 0 : _l.tip_screen) === null || _m === void 0 ? void 0 : _m.send_tip_button_title) || 'SEND TIP'
            });
            return update;
        }
        update.tip.customize = Object.assign(Object.assign({}, update.tip.customize), { status: update.tip.customize.status || 'success' });
        if (!update.tip.description && update.tip.customize.status_message) {
            update.tip.description = update.tip.customize.status_message;
        }
        const isIntegrated = this.payloadRepository.getIntegrated().value;
        if (isIntegrated) {
            update.interactions.push({
                type: 'primary',
                action: 'continue',
                text: texts.value.continue_button_title || ((_q = (_p = (_o = this.configurationRepository.configuration.value.tip) === null || _o === void 0 ? void 0 : _o.components) === null || _p === void 0 ? void 0 : _p.tip_screen) === null || _q === void 0 ? void 0 : _q.continue_button_title) || 'CONTINUE'
            });
        }
        return update;
    }
    execute() {
        this.repository.tip.observe(this, value => {
            this.tipState.next(this.getTipState(Object.assign({}, value)));
        });
        return this.tipState;
    }
};
GetTipStateUseCase = __decorate([
    injectable(),
    __param(0, inject(ITipRepositoryType)),
    __param(1, inject(ITipConfigurationRepositoryType)),
    __param(2, inject(ITipPayloadRepositoryType)),
    __param(3, inject(IConfigurationRepositoryType)),
    __metadata("design:paramtypes", [Object, Object, Object, Object])
], GetTipStateUseCase);
export { GetTipStateUseCase };
